import React, { useEffect, useState } from "react";
import { AuthPaymentLoanCard } from "./auth-payment-loan-card.component";
import Show from "../../../utils/show.component";

export const AuthPaymentLoanList = (props) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener("resize", () => setWindowWidth(window.innerWidth));

    return () => window.removeEventListener("resize", () => setWindowWidth(window.innerWidth));
  }, []);

  const cardStateConstructor = () => {
    const stateObject = {};
    props.loansArray.forEach((loan) => {
      stateObject[loan.AccountHash] = { showPopupMenu: false };
    });

    return stateObject;
  };

  const [cardStateController, setCardStateController] = useState(cardStateConstructor());

  // Function intended to check if the cardStateController object matches the
  // loan hashes in the loansArray prop. If it's false, it is probably
  // the frame on which we received the loansArray data from the endpoint and
  // triggered the usEffect to create the card controller
  const loansMatchStateObject = () => {
    const loansHashArray = props.loansArray.map((loan) => loan.AccountHash);
    const stateHashArray = Object.keys(cardStateController);

    let synced = true;

    loansHashArray.forEach((hash, index) => {
      if (hash !== stateHashArray[index]) {
        synced = false;
      }
    });

    return synced;
  };

  const closeAllPopupMenus = () => {
    setCardStateController(cardStateConstructor());
  };

  const generateSingleCardToggle = (accountHash) => {
    return () => {
      const currentState = cardStateController[accountHash].showPopupMenu;

      window.dispatchEvent(new CustomEvent("closeAllPopupMenusAndAuthModals"));

      setCardStateController((state) => {
        return {
          ...cardStateConstructor(),
          [accountHash]: { showPopupMenu: !currentState },
        };
      });
    };
  };

  useEffect(() => {
    setCardStateController(cardStateConstructor());
  }, [props.loansArray]);

  // This is added so we can reliably call an event from deep children
  // and close all popup menus and modals, including auth modal and '...' popup menu
  useEffect(() => {
    const handleAllClosePopupMenusAndAuthModals = () => {
      props.showAuthPaymentModal(false);
      closeAllPopupMenus();

      window.dispatchEvent(new CustomEvent("closeFuturePaymentCancellationModals"));
    };

    window.addEventListener(
      "closeAllPopupMenusAndAuthModals",
      handleAllClosePopupMenusAndAuthModals
    );

    return () =>
      window.removeEventListener(
        "closeAllPopupMenusAndAuthModals",
        handleAllClosePopupMenusAndAuthModals
      );
  }, [closeAllPopupMenus, props.showAuthPaymentModal]);

  const mapLoans = (loansArray) => {
    const mappedLoans = loansArray.map((loan) => {
      return (
        <AuthPaymentLoanCard
          {...loan}
          memberFromDI={props.memberFromDI}
          windowWidth={windowWidth}
          internalAccounts={props.authPayment.internalAccounts}
          cardState={cardStateController[loan.AccountHash]}
          togglePopupMenu={generateSingleCardToggle(loan.AccountHash)}
          closeAllPopupMenus={closeAllPopupMenus}
          showAuthPaymentModal={props.showAuthPaymentModal}
          callAuthGeneratePayoff={props.callAuthGeneratePayoff}
          // Only included here to bypass payment type modal until we add more payment types for
          // recurring payments
          setPaymentInfo={props.setPaymentInfo}
        />
      );
    });

    return mappedLoans;
  };

  const memberName = props.loansArray.length > 0 ? props.loansArray[0].MemberName : null;
  const firstName = memberName ? memberName.split(" ")[0] : null;

  // Return nothing if the loansArray prop and cardStateController are mismatched
  // To give them a moment to properly sync up
  if (!loansMatchStateObject()) {
    return <div></div>;
  }

  if (!props.loansArray.length && props.loansLoaded) {
    return (
      <h3 className="m-3 text-center" data-e2e-id="noLoans">
        There are no loans to be paid at this time.
      </h3>
    );
  }

  return (
    <div>
      <div className="mx-5 mb-4 mt-2 text-centered">
        <Show condition={!window.ReactNativeWebView}>
          <h2 className="bolder">Loan Payments</h2>
        </Show>
        <div className="m-auto text-centered" style={{ maxWidth: "570px", fontSize: "14px" }}>
          Your loans are listed below. You can setup or change your AutoPay, make a payment, or
          manage your loan.
        </div>
      </div>
      {/* Don't show the list of loans until the internal accounts have been loaded */}
      <Show condition={props.authPayment.internalAccountsLoaded}>
        <div className="px-2 m-auto" data-e2e-id="loanListContainer">
          {mapLoans(props.loansArray)}
        </div>
      </Show>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/loan-list/auth-payment-loan-list.component.js